import React, { forwardRef } from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../../components/button/Button";
import { Icon } from "../../../../../components/icon/Icon";

export const CreateRuleButton = forwardRef(function CreateRuleButton(
  { disabled, onClick },
  ref
) {
  return (
    <div className={"create-rule"}>
      <Button
        color={"secondary"}
        onClick={onClick}
        disabled={disabled}
        size={"large"}
        ref={ref}
      >
        <Icon icon={"fa-regular fa-plus-circle"} />
        <span>
          <FormattedMessage id={"create_rule"} />
        </span>
      </Button>
    </div>
  );
});
